/**
 * ResponsavelWebhookCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelWebhook} from '@/model/resource/ResponsavelWebhook'

/* TODO: review generated class */
@HttpExclude()
export class ResponsavelWebhookCollection extends PageCollection<
  ResponsavelWebhook
> {
  constructor() {
    super(ResponsavelWebhook)
  }

  queryAsPage() {
    return this.listResponsavelWebhook()
  }

  async listResponsavelWebhook() {
    return await Request.get(`/admin/responsavel-webhook`, {
      params: this.params,
    })
      .name('listResponsavelWebhook')
      .as(this)
      .getResponse()
  }

  async listCsvResponsavelWebhook() {
    return await Request.get(`/admin/responsavel-webhook/csv`, {
      params: this.params,
    })
      .name('listCsvResponsavelWebhook')
      .as(this)
      .getResponse()
  }
}
